import Vue from "vue";
import VueI18n from "vue-i18n";
import $store from "@/store";
import { getSiteContext, SITE_CONTEXT } from "@/utils/siteContext";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);

  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);

    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/**
 * Gets the default locale based on site context
 * @returns {string} Default locale code
 */
function getDefaultLocaleByContext() {
  const siteContext = getSiteContext();
  
  return siteContext === SITE_CONTEXT.NORWEGIAN ? 'no' : 'sv';
}

function getStartingLocale() {
  let locale = null;

  if ($store.getters.getAppLocale) {
    locale = $store.getters.getAppLocale;
  } else {
    // Use site context-based detection
    locale = getDefaultLocaleByContext();
  }
  return locale;
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "sv",
  messages: loadLocaleMessages(),
});
